import { useUsers } from "hooks/useDataFetch";
import MaterialTable from "@material-table/core";

import React, { useEffect, useState } from "react";
import { muiTable } from "utils";
import moment from "moment";
import { Avatar, Button, IconButton, Switch } from "@mui/material";
import { db, useIsMounted } from "hooks";
import Swal from "sweetalert2";
import { DeleteForever, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ManageUser = () => {
  const [sortedData, setSortedData] = useState([]);

  const { data, loading } = useUsers();

  // console.log(data);

  const navigate = useNavigate();
  const isMounted = useIsMounted();

  const handleUserBlock = async (e, uid) => {
    try {
      await db.updateDb("users/" + uid, {
        isBlocked: e.target.checked,
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };
  const handleUserDelete = async (uid) => {
    try {
      await db.delateData("users/" + uid);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      if (!data) return;

      const sorted = data?.sort((a, b) => {
        return parseInt(b.createdAt) - parseInt(a.createdAt);
      });
      setSortedData(sorted);
    }
  }, [isMounted, data]);

  return (
    <main className="dashboard-user-manage">
      <MaterialTable
        title="Users"
        isLoading={loading}
        data={sortedData || []}
        options={{ ...muiTable.options() }}
        style={muiTable.styles}
        columns={[
          {
            title: "#",
            field: "sl",
            width: "5%",
            editable: "never",
            id: "sl",
          },
          {
            title: "Profile",
            field: "photoURL",
            render: (rowData) => {
              return (
                <Avatar
                  src={`https://avatars.dicebear.com/api/avataaars/${rowData?.displayName}.svg`}
                />
              );
            },
          },
          {
            title: "Name",
            field: "displayName",
          },
          {
            title: "Email",
            field: "email",
          },
          {
            title: "Phone",
            field: "phoneNumber",
          },
          {
            title: "Joined",
            field: "createdAt",
            type: "date",
            render: (rowData) => {
              return moment(parseInt(rowData?.createdAt)).format("DD-MMM-YYYY");
            },
          },
          {
            title: "Blocked",
            field: "isBlocked",
            render: (rowData) => {
              return (
                <Switch
                  checked={rowData?.isBlocked}
                  onClick={(e) => {
                    handleUserBlock(e, rowData?.uid);
                  }}
                />
              );
            },
          },
          {
            title: "Delete User",
            render: (rowData) => {
              return (
                <IconButton
                  onClick={() => {
                    handleUserDelete(rowData?.uid);
                  }}
                >
                  <DeleteForever />
                </IconButton>
              );
            },
          },
          {
            title: "View Profile",
            render: (rowData) => {
              return (
                <Button
                  startIcon={<Edit />}
                  className="view-supplier-btn-edit"
                  onClick={() => {
                    navigate(`/admin/users/view/${rowData?.uid}`);
                  }}
                >
                  View
                </Button>
              );
            },
          },
        ]}
      />
    </main>
  );
};

export default ManageUser;
